/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { groupDataSchema } from "./groupDataSchema.ts";
import { typeOrganizationSchema } from "./typeOrganizationSchema.ts";
import { z } from "zod";

export const accountOrganizationSchema = z.object({
      "id": z.string(),
  "name": z.string(),
  "description": z.string().optional(),
  "crpcen": z.string(),
  "codeNs": z.string().describe("Code Notariat Service de l'étude associée à l'annonce.").optional(),
  "type": z.lazy(() => typeOrganizationSchema).describe("Type d'organisation"),
  "domains": z.array(z.string()).optional(),
  "software": z.array(z.string()).optional(),
  "groups": z.array(z.lazy(() => groupDataSchema).describe("Liste des logiciels attribués au membre dans l'organisation")).optional()
      })